import { ORDER_BY } from "@website-builder/utilities-index";
import { formatDate, sortNumberBy } from "@website-builder/utilities-index";
import {
	getStoriesByContentType,
	getImageConfig,
	filterBySlug,
	richTextResolver,
} from "@website-builder/utilities-index";

export const contentType = "Blog";

export default (
	{ header, blogsPerPage = 5, allowTitleNavigation = false },
	{ storyList = [], basicConfig = null },
) => {
	// filter by content type blog
	const list = storyList?.[contentType] || [];
	let blogList = getBlogItemProps(list, basicConfig);
	blogList = sortNumberBy(blogList, "dateInMilliSec", ORDER_BY.ASCENDING);
	return {
		header,
		blogList,
		blogsPerPage: parseInt(blogsPerPage, 10),
		allowTitleNavigation,
	};
};

export const getBlogItemProps = (list, basicConfig) => {
	return list.map(
		({
			content: { title, description, blogBannerImage },
			full_slug,
			published_at = null,
		}) => {
			return {
				header: title,
				description,
				imageConfig: getImageConfig(blogBannerImage, basicConfig),
				full_slug,
				publishedDate: published_at ? formatDate(published_at) : "",
				dateInMilliSec: published_at ? new Date(published_at).getTime() : 0,
			};
		},
	);
};

export const filterBlogsByCategories = (pages) => {
	if (typeof window !== "undefined") {
		let filterSlug = window.location.pathname;
		// remove storyblok space name from path
		if (process.env.GATSBY_TEMPLATE === "PREVIEW") {
			[, , ...filterSlug] = filterSlug.split("/");
			filterSlug = filterSlug.join("/");
		} else {
			filterSlug = filterSlug.replace("/", "");
		}

		if (filterSlug) {
			return filterBySlug(pages, filterSlug);
		}
		return pages;
	}
};
